import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { openUrlForAll } from '@src/slide/infrastructure/module/independent/url/open-url';

export const getScenarioUrlForMiniprogram = (ownerNick, requestPermitType) => {
    // eslint-disable-next-line prefer-destructuring
    const url = window.location.href.split('#')[0];

    let miniProgramUrl = '/pages/followEditGuide/followEditGuide?';
    miniProgramUrl += `ownerNick=${ownerNick}&requestPermitType=${requestPermitType}`;
    miniProgramUrl += `&url=${encodeURIComponent(url)}`;
    return miniProgramUrl;
};

export const redirectToScenario = (ownerNick, requestPermitType, disableBtns) => {
    // eslint-disable-next-line prefer-destructuring
    const url = window.location.href.split('#')[0];
    if (!browser.isMiniProgram) {
        // 移动端进入scenario页面
        // eslint-disable-next-line no-undef
        openUrlForAll({
            replace: true,
            url: `https://${window.location.hostname}/scenario/followGuide.html?nick=${ownerNick}&disableActionButtons=${disableBtns}&requestPermitType=${requestPermitType}&url=${encodeURIComponent(url)}`,
        });
    } else {
        // 小程序进入followEditGuide页面
        const miniProgramUrl = getScenarioUrlForMiniprogram(ownerNick, requestPermitType);
        window.wx.miniProgram.redirectTo({
            url: miniProgramUrl,
        });
    }
};
